import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  block?: boolean;
  busy?: boolean;
  children: ReactNode;
}

/**
 * Schaltflaeche.
 *
 * `busy` sperrt die Schaltflaeche und zeigt einen Ladehinweis. Beides gehoert
 * zusammen: Eine Schaltflaeche, die waehrend eines laufenden Aufrufs
 * bedienbar bleibt, fuehrt zu doppelt angelegten Datensaetzen.
 */
export function Button({
  variant = 'secondary',
  block = false,
  busy = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = ['button', `button--${variant}`, block ? 'button--block' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} disabled={disabled ?? busy} {...rest}>
      {busy ? <span className="spinner" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
